<template>
  <b-container>

    <!-- modal borrar evento -->
    <b-modal
        v-model="ModalBorrarEvento"
        persistent
        title="Confirmación"
        size="lg"
        centered
    >
      <b-container fluid>
        <b-row class="m-1 text-left">
          <b-col cols="12">
            ¿ Estás seguro de eliminar el evento con fecha <b> {{ this.evento_form.fecha_inicio}}</b> a hora <b> {{ this.evento_form.hora_inicio}}</b> ?
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <div class="w-100">
          <b-button
              variant="primary"
              size="sm"
              class="float-right"
              @click="hideModalBorrarConfirmacion()"
          >
            Cancelar
          </b-button>
          <b-button
              variant="danger"
              size="sm"
              class="float-right mx-2"
              @click="eliminarEvento()"
          >
            Eliminar
          </b-button>
        </div>
      </template>

    </b-modal>

    <!-- modal crear nuevo elemento -->
    <b-modal   no-close-on-backdrop centered size="lg"
               hide-footer
               ref="ModalCrearSesion"
               title="Creando evento para la sesión"
               v-model="ModalCrearEvento"
               persistent>
      <b-card
          tag="article"
          class="mb-2">
        <b-alert show variant="primary" class="p-3 text-justify">
          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor" class="bi bi-info-circle-fill mr-2" viewBox="0 0 16 16">
            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
          </svg>
          A continuación especifique los siguientes campos
        </b-alert>
        <b-card-text>
          <b-row>
            <div class="col-sm-1"></div>
            <div class="col-sm-10">
              <b-form>

                <div >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" style="color: red" class="bi bi-youtube" viewBox="0 0 16 16">
                    <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z"/>
                  </svg> <small> <i> Liga video youtube en vivo</i></small>
                </div>
                <b-form-input placeholder="Ej https://www.youtube.com/watch?v=jfKfPfyJRdk"  v-model="evento_form.liga_youtube_enVivo" aria-label="Plantel"></b-form-input>

                <div class="mt-2">
                  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="18" height="18" viewBox="0 0 48 48">
                    <path fill="#CFD8DC" d="M30,13H18l-7,11l7,11h12l7-11L30,13z M24,29c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S26.8,29,24,29z"></path><path fill="#2196F3" d="M34.8,7.2C34.3,6.5,33.5,6,32.6,6H15.4c-0.9,0-1.7,0.5-2.2,1.2l-5.8,9.5L12,24l6.3-10h20.6L34.8,7.2z M16,11c-0.6,0-1-0.4-1-1s0.4-1,1-1c0.6,0,1,0.4,1,1S16.6,11,16,11z M32,11c-0.6,0-1-0.4-1-1s0.4-1,1-1c0.6,0,1,0.4,1,1S32.6,11,32,11z"></path><path fill="#FFC107" d="M18.3,34L7.4,16.8l-3.6,5.9c-0.5,0.8-0.5,1.9,0,2.7l9.4,15.4c0.5,0.8,1.3,1.2,2.2,1.2h9.1l5.1-8H18.3z M8,25c-0.6,0-1-0.4-1-1s0.4-1,1-1c0.6,0,1,0.4,1,1S8.6,25,8,25z M16,39c-0.6,0-1-0.4-1-1s0.4-1,1-1c0.6,0,1,0.4,1,1S16.6,39,16,39z"></path><path fill="#1976D2" d="M7.4 16.8L12 24 14.4 20.3 8.5 15z"></path><path fill="#F9A825" d="M24.6 42L29.7 34 24.9 34 22.6 42z"></path><path fill="#DD2C00" d="M44.2,22.7L38.9,14h-9.2L36,24L24.6,42h8c0.9,0,1.7-0.5,2.2-1.2l9.5-15.4C44.8,24.5,44.8,23.5,44.2,22.7z M32,39c-0.6,0-1-0.4-1-1s0.4-1,1-1c0.6,0,1,0.4,1,1S32.6,39,32,39z M40,25c-0.6,0-1-0.4-1-1s0.4-1,1-1c0.6,0,1,0.4,1,1S40.6,25,40,25z"></path><path fill="#BF360C" d="M38.9 14L29.7 14 32.2 17.9 40.1 16z"></path>
                  </svg>
                   <small> <i> Liga acceso de cloud Storage de video (se puede editar despúes en caso de aplicar) </i></small>
                </div>
                <b-form-input placeholder="Ej gs://nivelando_envivo/Sesión 9.mp4" v-model="evento_form.liga_cloudStorage" aria-label="Plantel"></b-form-input>
                <!--
                                <label> <small> Seleccionar video de Youtube</small></label>

                              <v-select
                                    label="title"
                                    size="lg"
                                    class="my-3"
                                    placeholder="Elegir"
                                    v-model="evento_form.youtube"
                                    :options='youtubeItems'
                                >
                                  &lt;!&ndash;
                                  <template slot="option" slot-scope="option">
                                    <b-col>
                                      {{ option.title }}<br>
                                      <small style="color:#dedede"> {{ option.Description_formatted }} </small>
                                    </b-col>
                                  </template>
                                  &ndash;&gt;
                                  <template v-slot:no-options="{ search, searching }">
                                    <template v-if="searching">
                                      No resultados para <em>{{ search }}</em
                                    >.
                                    </template>
                                    <em v-else style="opacity: 0.5">Elegir video de youtube</em>
                                  </template>
                                </v-select>-->

                <b-row class="d-flex align-items-start justify-content-start my-3">
                  <b-col>
                    <b-form-datepicker locale="es"
                                       placeholder="Fecha de inicio"
                                       v-model="evento_form.fecha_inicio"
                                       size="sm"
                                       label-help=''
                                       label-today-button='Hoy'
                                       today-button
                                       label-no-date-selected='No se ha elegido fecha'
                    >
                    </b-form-datepicker>
                  </b-col>
                  <b-col>
                    <b-form-datepicker locale="es"
                                       placeholder="Fecha finalización"
                                       v-model="evento_form.fecha_finalizacion"
                                       size="sm"
                                       label-help=''
                                       label-today-button='Hoy'
                                       today-button
                                       label-no-date-selected='No se ha elegido fecha'
                    >
                    </b-form-datepicker>
                  </b-col>
                </b-row>
                <b-row class="d-flex align-items-start justify-content-start my-3">
                  <b-col>
                    <b-form-timepicker
                        size='sm'
                        now-button
                        label-now-button='Ahora'
                        label-hours='Hr'
                        label-minutes='Min'
                        hide-header
                        label-close-button='Cerrar'
                        placeholder="Hora inicio"
                        v-model="evento_form.hora_inicio" locale="es">
                    </b-form-timepicker>
                  </b-col>
                  <b-col>
                    <b-form-timepicker
                        size='sm'
                        now-button
                        label-now-button='Ahora'
                        label-hours='Hr'
                        label-minutes='Min'
                        hide-header
                        label-close-button='Cerrar'
                        placeholder="Hora fin"
                        v-model="evento_form.hora_fin" locale="es">
                    </b-form-timepicker>
                  </b-col>
                </b-row>
                <hr>
                <label for="">Vigencia</label>
                <b-row class="d-flex align-items-start justify-content-start my-3">
                  <b-col>
                    <b-form-datepicker locale="es"
                                       placeholder="Fecha de inicio"
                                       v-model="evento_form.fecha_vigencia_inicio"
                                       size="sm"
                                       label-help=''
                                       label-today-button='Hoy'
                                       today-button
                                       label-no-date-selected='No se ha elegido fecha'
                    >
                    </b-form-datepicker>
                  </b-col>
                  <b-col>
                    <b-form-datepicker locale="es"
                                       placeholder="Fecha finalización"
                                       v-model="evento_form.fecha_vigencia_finalizacion"
                                       size="sm"
                                       label-help=''
                                       label-today-button='Hoy'
                                       today-button
                                       label-no-date-selected='No se ha elegido fecha'
                    >
                    </b-form-datepicker>
                  </b-col>
                </b-row>

                <b-row class="d-flex align-items-start justify-content-start mt-3 my-1">
                  <div class="w-100">
                    <b-button
                        variant="primary"
                        size="sm"
                        class="float-right"
                        @click="HideModalCrearEvento()"
                    >Cancelar
                    </b-button>

                    <b-button v-if="evento_form.editar==true"
                              variant="info"
                              size="sm"
                              class="float-right mx-2"
                              @click="actualizarEvento()"
                    >
                      Actualizar registro
                    </b-button>

                    <b-button v-if="evento_form.editar==false"
                              variant="success"
                              size="sm"
                              class="float-right mx-2"
                              @click="guardarEvento()"
                    >
                      Guardar
                    </b-button>
                  </div>
                </b-row>


              </b-form>
            </div>
            <div class="col-sm-1"></div>
          </b-row>
        </b-card-text>

      </b-card>
    </b-modal>

    <b-row>
      <b-col cols="12">
        <div class="card card-block">
          <div class="card-body p-2">
            <div class="d-flex justify-content-between align-items-center p-2">
              <b-jumbotron lead="Eventos del curso"></b-jumbotron>
            </div>

            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/cursos-all" class="">Cursos</router-link></li>
                <li class="breadcrumb-item active" aria-current="page"> Eventos </li>
              </ol>
            </nav>

            <b-row  style="display: flex; justify-content: space-between;" class="my-3 mx-3">
              <b-button @click="volver()"
                        class="btn-studioAPP"
                        variant="outline-warning"> Volver
              </b-button>
              <div>
                  <b-button :disabled="limiteEventoAlcanzado"
                            @click="ShowModalCrearEvento"
                            class="btn-studioAPP"
                            variant="outline-warning"
                            v-b-tooltip.html
                            title="Sólo 1 evento por curso es permitido "
                          > Crear nuevo evento <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="18" height="18" viewBox="0 0 48 48">
                    <circle cx="24" cy="24" r="6" fill="#f44336"></circle><path fill="#f44336" d="M17.09,16.789L14.321,13.9C11.663,16.448,10,20.027,10,24s1.663,7.552,4.321,10.1l2.769-2.889 C15.19,29.389,14,26.833,14,24C14,21.167,15.19,18.61,17.09,16.789z"></path><path fill="#f44336" d="M33.679,13.9l-2.769,2.889C32.81,18.611,34,21.167,34,24c0,2.833-1.19,5.389-3.09,7.211l2.769,2.889 C36.337,31.552,38,27.973,38,24S36.337,16.448,33.679,13.9z"></path><g><path fill="#f44336" d="M11.561,11.021l-2.779-2.9C4.605,12.125,2,17.757,2,24s2.605,11.875,6.782,15.879l2.779-2.9 C8.142,33.701,6,29.1,6,24S8.142,14.299,11.561,11.021z"></path><path fill="#f44336" d="M39.218,8.121l-2.779,2.9C39.858,14.299,42,18.9,42,24s-2.142,9.701-5.561,12.979l2.779,2.9 C43.395,35.875,46,30.243,46,24S43.395,12.125,39.218,8.121z"></path></g>
                  </svg>
                  </b-button>
              </div>
            </b-row>

            <b-table class="table data-table"
                     :items="eventos_items"
                     :fields="eventos_headers"
                     :current-page="currentPage"
                     :per-page="perPage"
                     :filter="filter"
                     :filter-included-fields="filterOn"
                     stacked="md"
                     show-empty
                     small
            >
              <template #empty="scope">
                <b-alert show variant="info">{{ scope.emptyText='Por el momento no hay registros que mostrar' }}</b-alert>
              </template>
              <template #emptyfiltered="scope">
                <b-alert show variant="warning">
                  {{ scope.emptyFilteredText='No hay registros que concuerden con los parámetros de búsqueda.' }}
                </b-alert>
              </template>

              <template #cell(liga_youtube_enVivo)="row">
                <a :href="row.item.liga_youtube_enVivo" target="_blank">
                  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="50" height="50" viewBox="0 0 512 512">
                    <path fill="#EF4823" d="M460.2,185.5c-21.3-43.4-61.6-77.5-104.2-99C313.2,64.8,263.7,53.4,215.9,61C137,73.5,60.5,131.3,38,208.9c0,0.9-0.2,1.7-0.7,2.6c-0.4,1.4-0.8,2.9-1.1,4.3c-0.5,1-1,2-1.4,3.1c-0.1,0.9-0.3,1.9-0.4,2.7c-0.9,4.1-2,8.2-2.7,12.3c-1.4,7.7-1.1,15.7-3.8,23c-0.2,2.1-0.5,4.2-0.8,6.3c0,0.3,0,0.5,0,0.7c-0.5,4.4-0.9,8.8-1.3,13.2c-0.8,9.2-1.2,18.4-1.1,27.6c0.3,18.1,2.4,36.2,6.9,53.7c8.7,33.3,25.5,64.8,52,87.3c18.2,15.5,39.5,25.7,62.4,32.3c25,7.3,51,11.4,77.1,11.5c51.5,0.1,103.2-13.9,145.6-43.7C447.1,390.7,506.2,279,460.2,185.5z M390.5,324.7c-0.3,11-1.7,22.7-7.8,32.1c-6.7,10.5-16.5,17.3-28.1,21.8c-24,9.4-50.4,9.4-75.8,8.5c-31.2-1-62.2-3.4-93.4-2.1c-20.4,0.8-44,2.3-62.5-8.2c-21.5-12.1-27.7-37.3-29.8-60.2c-1.2-12.8-1.4-25.6-1.8-38.5c-0.5-12.5-1.9-25-1.3-37.5c0.7-11.9,2.6-24,8.4-34.6c5.2-9.7,12.5-17.8,20.6-25c5.8-2.4,11.7-4.6,17.8-6.4c28.3-0.6,56.5,0,84.8,0.4c30.2,0.4,60.1-4.9,90.2-6.6c18.9-1.1,41.5-1,56.8,12c18.5,15.6,19.8,44.3,19.9,66.7c0,14-0.8,28.1-0.1,42.1C388.9,301.1,390.8,312.8,390.5,324.7z"></path><path fill="#D6E5E5" d="M379.2,314.4c-0.8-12.5-2.1-24.9-2-37.4c0.1-14.2,0.8-28.4-0.1-42.6c-0.8-12.4-2.1-27.1-9-37.8c-11.2-17.5-34.4-18.2-53.1-17.2c-30.2,1.6-60.3,7.1-90.7,6.7c-27.1-0.3-54.1-0.9-81.2-0.5c-0.2,0-0.3,0-0.5,0c-1.4,0-2.8,0-4.1,0.1c-0.8,0-1.6,0-2.5,0c0,0.1-0.1,0.1-0.1,0.2c-1.8,0.3-3.6,0.7-5.2,1.4c-0.7,0.3-1.3,0.6-2,1c-0.3-0.1-0.6-0.3-0.9-0.5c-14.2,12.2-24.3,26.9-26.4,46.2c-2.1,18.7,0.6,38,1.2,56.8c0.6,19,1,39.5,8.8,57.2c6.9,15.6,20.1,22.8,36.5,25.2c10.6,1.5,21.2,1.4,31.9,1c14.7-0.6,29.4-0.8,44.2-0.5c28.6,0.6,57.3,4,85.8,2.4c22.4-1.3,55.1-5.4,65.4-28.9C379.8,336.9,379.9,325.4,379.2,314.4z M274.5,277.3c-0.1,1-0.4,2-1.2,3c-3.3,4.3-9,7.1-13.5,10.1c-5,3.4-10.1,6.6-15.2,9.9c-10.1,6.6-20.1,13.3-29.4,20.9c-2.1,1.7-4.3,1.4-5.9,0.2c-1.5-0.7-2.5-2.2-2.7-4.3c-1.2-26-3-52-3-78c0-3,1.9-4.8,4.2-5.5c1.3-0.7,3-0.8,4.8,0.1c6.7,3.6,13.2,7.6,19.9,11.3c6.3,3.6,13.6,6.2,19.7,10c3.9,2.5,7.7,5.1,11.6,7.6c1.8,1.2,3.6,2.4,5.5,3.4c0.7,0.4,1.4,0.8,2.2,1.1c0.2,0.1,0.3,0.1,0.3,0.1C276.4,268.3,278.6,275,274.5,277.3z"></path><path fill="#EF4823" d="M261.7,274.5c-4.4-2.8-8.7-5.8-13.1-8.6c-6.1-3.9-13.2-6.5-19.5-10c-4.8-2.7-9.6-5.5-14.4-8.3c0.3,19.5,1.4,38.9,2.4,58.4c6.9-5.1,14.1-9.9,21.4-14.6c5.1-3.3,10.2-6.6,15.2-9.9c2.5-1.7,5-3.4,7.5-5.1c0.5-0.4,1-0.8,1.6-1.2C262.4,274.9,262.1,274.7,261.7,274.5z"></path><path d="M459.9,164.6C434.7,124.2,393.9,93,351.2,73c-43.3-20.2-92.9-29.5-140.3-21.3C129.1,65.9,51,126.4,28,207.4c-3.3,5.5-3.8,13.1-5.2,19.2c-1,4.3-1.7,8.7-2.3,13.1c-0.1,0.4-0.1,0.9-0.2,1.3c-0.1,0.3-0.2,0.5-0.2,0.8c-0.8,4.2-1.5,8.4-2.1,12.6c0,0.1-0.1,0.1-0.1,0.2c-0.5,1.2-0.6,2.3-0.4,3.2c-1,8.1-1.7,16.2-2.3,24.3c-0.8,11.4-0.9,22.9-0.3,34.3c1.3,22.3,5.6,44.5,13.3,65.5c15.3,41.8,45.5,76.5,86.1,95.3c23.1,10.6,48.8,16.7,73.9,20c25.5,3.3,51.5,3.1,77-0.6c50.9-7.4,98.5-29.7,136.1-64.8c36.4-33.9,65-77.6,78.1-125.8C492.7,258,486.4,207.1,459.9,164.6z M368.6,445.9c-42.4,29.8-94.1,43.8-145.6,43.7c-26.1-0.1-52.1-4.2-77.1-11.5c-22.9-6.7-44.2-16.8-62.4-32.3c-26.5-22.5-43.3-54-52-87.3c-4.6-17.5-6.6-35.6-6.9-53.7c-0.2-9.2,0.2-18.4,1.1-27.6c0.4-4.4,0.8-8.8,1.3-13.2c0-0.2,0-0.5,0-0.7c0.3-2.1,0.6-4.2,0.8-6.3c2.7-7.3,2.4-15.4,3.8-23c0.8-4.1,1.8-8.2,2.7-12.3c0.2-0.8,0.3-1.7,0.4-2.7c0.4-1,0.9-2.1,1.4-3.1c0.4-1.4,0.7-2.9,1.1-4.3c0.5-0.9,0.8-1.8,0.7-2.6C60.5,131.3,137,73.5,215.9,61c47.9-7.6,97.3,3.8,140.1,25.5c42.6,21.5,82.8,55.7,104.2,99C506.2,279,447.1,390.7,368.6,445.9z"></path><path d="M388.4,289.3c-0.6-14,0.2-28.1,0.1-42.1c-0.1-22.4-1.4-51-19.9-66.7c-15.3-13-37.9-13-56.8-12c-30.1,1.7-60,7-90.2,6.6c-28.3-0.4-56.5-0.9-84.8-0.4c-6.1,1.7-12,3.9-17.8,6.4c-8.1,7.2-15.4,15.3-20.6,25c-5.7,10.7-7.7,22.7-8.4,34.6c-0.7,12.5,0.8,25,1.3,37.5c0.5,12.8,0.6,25.7,1.8,38.5c2.2,22.9,8.4,48.1,29.8,60.2c18.5,10.4,42.1,9,62.5,8.2c31.3-1.3,62.2,1.1,93.4,2.1c25.4,0.8,51.8,0.9,75.8-8.5c11.5-4.5,21.3-11.3,28.1-21.8c6.1-9.4,7.5-21.1,7.8-32.1C390.8,312.8,388.9,301.1,388.4,289.3z M375.3,347.2c-10.3,23.5-43,27.6-65.4,28.9c-28.6,1.6-57.3-1.8-85.8-2.4c-14.7-0.3-29.5-0.1-44.2,0.5c-10.6,0.4-21.3,0.5-31.9-1c-16.4-2.3-29.7-9.6-36.5-25.2c-7.8-17.7-8.2-38.2-8.8-57.2c-0.6-18.8-3.2-38.1-1.2-56.8c2.1-19.3,12.2-34,26.4-46.2c0.3,0.2,0.6,0.4,0.9,0.5c0.6-0.4,1.3-0.7,2-1c1.7-0.7,3.4-1.1,5.2-1.4c0-0.1,0.1-0.1,0.1-0.2c0.8,0,1.6,0,2.5,0c1.4-0.1,2.8-0.1,4.1-0.1c0.2,0,0.4,0,0.5,0c27.1-0.4,54.1,0.1,81.2,0.5c30.3,0.4,60.4-5.2,90.7-6.7c18.7-1,41.9-0.3,53.1,17.2c6.9,10.8,8.2,25.4,9,37.8c0.9,14.2,0.2,28.4,0.1,42.6c-0.1,12.5,1.2,24.9,2,37.4C379.9,325.4,379.8,336.9,375.3,347.2z"></path><path d="M271.7,267.4c-0.1,0-0.2-0.1-0.3-0.1c-0.8-0.3-1.5-0.7-2.2-1.1c-1.9-1-3.7-2.2-5.5-3.4c-3.9-2.5-7.6-5.2-11.6-7.6c-6.1-3.9-13.3-6.5-19.7-10c-6.6-3.7-13.2-7.7-19.9-11.3c-1.8-1-3.4-0.9-4.8-0.1c-2.2,0.7-4.2,2.5-4.2,5.5c0,26,1.8,52,3,78c0.1,2.2,1.2,3.6,2.7,4.3c1.6,1.3,3.8,1.5,5.9-0.2c9.3-7.6,19.3-14.3,29.4-20.9c5.1-3.3,10.2-6.6,15.2-9.9c4.5-3,10.2-5.9,13.5-10.1c0.8-1,1.1-2,1.2-3C278.6,275,276.4,268.3,271.7,267.4z M261.1,276.3c-2.5,1.7-5,3.4-7.5,5.1c-5,3.4-10.1,6.6-15.2,9.9c-7.2,4.7-14.4,9.5-21.4,14.6c-1-19.4-2.1-38.9-2.4-58.4c4.8,2.7,9.6,5.5,14.4,8.3c6.3,3.6,13.4,6.1,19.5,10c4.4,2.8,8.7,5.9,13.1,8.6c0.3,0.2,0.7,0.4,1,0.6C262.2,275.5,261.7,275.9,261.1,276.3z"></path>
                  </svg>
                </a>
              </template>

              <template #cell(liga_cloudStorage)="row">
                <div v-if="row.item.liga_cloudStorage">
                  <a :href="row.item.liga_cloudStorage" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="50" height="50" viewBox="0 0 48 48">
                      <path fill="#CFD8DC" d="M30,13H18l-7,11l7,11h12l7-11L30,13z M24,29c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S26.8,29,24,29z"></path><path fill="#2196F3" d="M34.8,7.2C34.3,6.5,33.5,6,32.6,6H15.4c-0.9,0-1.7,0.5-2.2,1.2l-5.8,9.5L12,24l6.3-10h20.6L34.8,7.2z M16,11c-0.6,0-1-0.4-1-1s0.4-1,1-1c0.6,0,1,0.4,1,1S16.6,11,16,11z M32,11c-0.6,0-1-0.4-1-1s0.4-1,1-1c0.6,0,1,0.4,1,1S32.6,11,32,11z"></path><path fill="#FFC107" d="M18.3,34L7.4,16.8l-3.6,5.9c-0.5,0.8-0.5,1.9,0,2.7l9.4,15.4c0.5,0.8,1.3,1.2,2.2,1.2h9.1l5.1-8H18.3z M8,25c-0.6,0-1-0.4-1-1s0.4-1,1-1c0.6,0,1,0.4,1,1S8.6,25,8,25z M16,39c-0.6,0-1-0.4-1-1s0.4-1,1-1c0.6,0,1,0.4,1,1S16.6,39,16,39z"></path><path fill="#1976D2" d="M7.4 16.8L12 24 14.4 20.3 8.5 15z"></path><path fill="#F9A825" d="M24.6 42L29.7 34 24.9 34 22.6 42z"></path><path fill="#DD2C00" d="M44.2,22.7L38.9,14h-9.2L36,24L24.6,42h8c0.9,0,1.7-0.5,2.2-1.2l9.5-15.4C44.8,24.5,44.8,23.5,44.2,22.7z M32,39c-0.6,0-1-0.4-1-1s0.4-1,1-1c0.6,0,1,0.4,1,1S32.6,39,32,39z M40,25c-0.6,0-1-0.4-1-1s0.4-1,1-1c0.6,0,1,0.4,1,1S40.6,25,40,25z"></path><path fill="#BF360C" d="M38.9 14L29.7 14 32.2 17.9 40.1 16z"></path>
                    </svg>
                  </a>
                </div>
                <div v-else>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor" class="bi bi-bag-x" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M6.146 8.146a.5.5 0 0 1 .708 0L8 9.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 10l1.147 1.146a.5.5 0 0 1-.708.708L8 10.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 10 6.146 8.854a.5.5 0 0 1 0-.708z"/>
                    <path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z"/>
                  </svg>
                </div>
              </template>

              <template #cell(horario)="row">
                <button type="button" class="btn btn-sm btn-success rounded-pill mt-2"><i class="ri-bill-fill"></i>{{row.item.horario}}</button>
              </template>

              <template #cell(detalles)="row">
                <b-button  pill variant="primary" size="sm" @click="unidades(row.item)" class="ml-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                       class="bi bi-trash-fill" viewBox="0 0 20 20">

                    <path d="M14.467,1.771H5.533c-0.258,0-0.47,0.211-0.47,0.47v15.516c0,0.414,0.504,0.634,0.802,0.331L10,13.955l4.136,4.133c0.241,0.241,0.802,0.169,0.802-0.331V2.241C14.938,1.982,14.726,1.771,14.467,1.771 M13.997,16.621l-3.665-3.662c-0.186-0.186-0.479-0.186-0.664,0l-3.666,3.662V2.711h7.994V16.621z"></path>
                  </svg>
                </b-button>
              </template>

              <template #cell(actions)="row">

                <div class="d-flex justify-content-around align-items-center">

                  <b-button variant="success" v-b-modal.modal-prevent-closing size="sm"
                            @click="EditMode(row.item)" class="mr-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                         class="bi bi-pencil-square" viewBox="0 0 20 20">
                      <path
                          d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                      <path fill-rule="evenodd"
                            d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                    </svg>
                  </b-button>

                  <b-button variant="danger" size="sm" @click="showModalBorrarConfirmacion(row.item)" class="ml-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                         class="bi bi-trash-fill" viewBox="0 0 20 20">
                      <path
                          d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
                    </svg>
                  </b-button>
                </div>
              </template>


            </b-table>


          </div><!--card-body p-2-->

        </div><!--  card card-block -->


      </b-col><!-- cols 12-->



    </b-row>


  </b-container>
</template>

<script>
import firebase from '@/firebaseConfRtdb/init';
import firebaseMixin from '@/mixins/FirebaseMixin.js';
import toast from "@/mixins/ToastMixin.js";
import Bugsnag from '@bugsnag/js';
import EventoService from '@/services/EventoService';
import EventoStreamService from "../../../services/Evento/EventoStreamService";

export default {

  mounted () {

    this.getEventos(this.$route.params.id);

  },
  mixins:[toast,firebaseMixin],
  name: "CursoEvento",
  data() {
    return {
      limiteEventoAlcanzado:false,
      youtubeItems:[],
      youtubeItems_count:0,

      ModalCrearEvento:false,
      ModalBorrarEvento:false,
      curso:{
        nombre:'',
        id:(this.$route.params.id) ? (this.$route.params.id) : 0,
      },
      evento_form:{
        liga_cloudStorage:'',
        liga_youtube_enVivo:'',
        id:0,
        editar:false,
        fecha_inicio: '',
        fecha_finalizacion : '',
        hora_inicio: null,
        hora_fin: null,

        youtube:{ label:'Elegir', id: 0 },
        fecha_vigencia_inicio : '',
        fecha_vigencia_finalizacion : ''
      },

      eventos_items:[],
      eventos_headers: [
        { label: '#',        key: 'evento_id'          ,  class: 'text-center'},
        { label: 'Título',   key: 'liga_youtube_enVivo'         , class: 'text-center'},
        { label: 'Google Cloud',   key: 'liga_cloudStorage'         , class: 'text-center'},

        { label: 'Fecha del Evento',   key: 'fecha_consumo_inicio'         , class: 'text-center'},
        { label: 'Hora del Evento',    key: 'horario'                      , class: 'text-center'},
        { label: '',                   key: 'actions',class: 'text-center'}
      ],

      /////////////
      totalRows: 1,
      currentPage: 1,
      perPage: 8,
      pageOptions: [5, 10, 15, { value: 100, text: "Ver muchos" }],
      filter: null,
      filterOn: [],
      search: ''
    }
  },
  methods: {
    saveToFirebase(id_eventoStream){
      let postData = {
        chat_habilitado: 0,
        encuestas_habilitado: 0,
        evento_streaming_id:id_eventoStream,
        stream_iniciado:1,
        stream_finalizado:0
      };
      firebase.database().ref('streaming-events').push(postData);
    },
    async getYoutubeVideos(){

      //segundo select, AHORA NO SE USA
      try {
        let response                = await EventoStreamService.getYoutubeVideos();
        let { resultSet}            = response.data;
        this.youtubeItems_count     = resultSet.count;
        this.youtubeItems           = resultSet.entries;
      } catch (error) {
        this.toast('b-toaster-bottom-center', true, 'Ocurrió un error, favor de comunicarse con su administrador 🙏', "danger" );
        Bugsnag.notify(
            new Error('Método: getYoutubeVideos() ' + error.message)
        );
      }
    },
    async eliminarEvento(){
      try {
        const response   = await EventoService.deleteEvento(this.evento_form.id);
        let {   success,
                message,
                color
              } = response.data;

        if(success){
          this.hideModalBorrarConfirmacion();
          await this.getEventos(this.curso.id);
        }
        this.toast('b-toaster-bottom-center', true, message, color );

      } catch (error) {
        this.toast('b-toaster-bottom-center', true, 'Ocurrió un error, favor de comunicarse con su administrador', "danger" );
        Bugsnag.notify(
            new Error('Método: eliminarEvento() ' + error)
        );
      }
    },
    showModalBorrarConfirmacion(item){
   //   console.log(item);
      this.evento_form.id             =item.id;
      this.evento_form.fecha_inicio   =item.fecha_consumo_inicio;
      this.evento_form.hora_inicio    =item.hora_inicio;
      this.ModalBorrarEvento          = true;
    },
    hideModalBorrarConfirmacion(){
      this.ModalBorrarEvento = false;
      this.resetForm();
    },
    EditMode(item){

      this.evento_form = {
                        id :item.id,
                        editar:true,
                        fecha_inicio: item.fecha_consumo_inicio,
                        fecha_finalizacion : item.fecha_consumo_termino,

                        fecha_vigencia_inicio: item.fecha_seleccion_inicio,
                        fecha_vigencia_finalizacion: item.fecha_seleccion_termino,
                        hora_inicio: item.hora_inicio,
                        hora_fin: item.hora_fin,
                        liga_youtube_enVivo: item.liga_youtube_enVivo,
                        liga_cloudStorage:item.liga_cloudStorage,
                        youtube:
                          {
                            label:item.titulo_video,
                            id:item.youtube_video_id,
                            title:item.titulo_video,
                            description:  item.descripcion_video,
                            thumbnails:{
                              default:{
                                url:item.thumbnail_video
                              }
                            }
                          },

      };
      this.ModalCrearEvento = true;
    },
    volver(){
      this.$router.push({name: 'Cursosall'});
    },
    resetForm(){
      this.evento_form = {
        id:0,
        editar:false,
        fecha_inicio: '',
        fecha_finalizacion : '',
        hora_inicio: null,
        hora_fin: null,
        liga_youtube_enVivo:"",
        liga_cloudStorage:"",

        youtube:{ label:'Elegir', id: 0 },
        fecha_vigencia_inicio : '',
        fecha_vigencia_finalizacion : ''
      }
    },

    HideModalCrearEvento(){
      this.ModalCrearEvento=false;
      this.resetForm();
    },
    ShowModalCrearEvento(){
      this.ModalCrearEvento=true;
    },

    async getEventos(curso_id) {
      // trae los eventos del curso x id
      try {

        //await this.getYoutubeVideos();

        let response = await EventoService.getEventosByCurso(curso_id);
        let { resultSet} = response.data;
        this.eventos_items= resultSet;
        this.limiteEventoAlcanzado = false;
        this.limiteEventoAlcanzado = (this.eventos_items.length >= 1);

      } catch (error) {
        this.toast('b-toaster-bottom-center', true, 'Ocurrió un error, favor de comunicarse con su administrador 🙏', "danger" );
        Bugsnag.notify(
            new Error('Método: getEventos() ' + error.message)
        );
      }

    },
    async actualizarEvento(){

      console.log('evento_form.youtube');
      console.log(this.evento_form.youtube);

        const formData = new FormData();

         // formData.append("evento_id",                     this.evento_form.id);
          formData.append("liga_youtube_enVivo",                     this.evento_form.liga_youtube_enVivo);
          formData.append("liga_cloudStorage",                 this.evento_form.liga_cloudStorage);
          formData.append("fecha_inicio", this.evento_form.fecha_inicio);
          formData.append("fecha_finalizacion", this.evento_form.fecha_finalizacion);
          formData.append("hora_inicio", this.evento_form.hora_inicio);
          formData.append("hora_fin", this.evento_form.hora_fin);
          formData.append("youtube_video_id",                     this.evento_form.youtube.id);
          formData.append("titulo_video",                         this.evento_form.youtube.title);
          formData.append("descripcion_video",                    this.evento_form.youtube.description);
          formData.append("thumbnail_video",                      this.evento_form.youtube.thumbnails.default.url);
          formData.append("fecha_vigencia_inicio",                 this.evento_form.fecha_vigencia_inicio);
          formData.append("fecha_vigencia_finalizacion",           this.evento_form.fecha_vigencia_finalizacion);
          formData.append("_method", "PUT");

/*        for (const [name, value] of formData.entries()) {
          console.log(`Field: ${name}, Value: ${value}`);
        }*/

      try{
        const response = await EventoService.updateEvento(this.evento_form.id, formData);
        let {   success,
                message,
                color
        } = response.data;
        console.log('response.data');
        console.log(response.data);
        if(success){
          this.toast('b-toaster-bottom-center', true, message, color );
        }
        await this.getEventos(this.curso.id);
        this.HideModalCrearEvento();
      } catch (error) {
        this.toast('b-toaster-bottom-center', true, 'Ocurrió un error, favor de comunicarse con su administrador 🙏', "danger" );
        Bugsnag.notify(
            new Error('Método: actualizarEvento() ' + error.message)
        );
      }
    },
    async guardarEvento(){
      try {
        let formData = new FormData();
            formData.append("liga_youtube_enVivo",          this.evento_form.liga_youtube_enVivo);
            formData.append("liga_cloudStorage",            this.evento_form.liga_cloudStorage);

            formData.append("curso_id",                     this.curso.id);
            formData.append("fecha_inicio",                 this.evento_form.fecha_inicio);
            formData.append("fecha_finalizacion",           this.evento_form.fecha_finalizacion);
            formData.append("hora_inicio",                  this.evento_form.hora_inicio);
            formData.append("hora_fin",                     this.evento_form.hora_fin );

         /*   formData.append("youtube_video_id",     this.evento_form.youtube.id);
            formData.append("titulo_video",         this.evento_form.youtube.title);
            formData.append("descripcion_video",    this.evento_form.youtube.description);
            formData.append("thumbnail_video",      this.evento_form.youtube.thumbnails.default.url);*/

            formData.append("fecha_vigencia_inicio",          this.evento_form.fecha_vigencia_inicio);
            formData.append("fecha_vigencia_finalizacion",    this.evento_form.fecha_vigencia_finalizacion);

        const response = await EventoService.saveEventoCurso(formData);
        let {   success,
                message,
                color,
                  id      //id eventoStream// ahora id del evento
        } = response.data;
        if(success){
          this.saveToFirebase(id);
          this.toast('b-toaster-bottom-center', true, message, color );
        }
        await this.getEventos(this.curso.id);
        this.HideModalCrearEvento();
      } catch (error) {
    //    this.toast('b-toaster-bottom-center', true, 'Ocurrió un error, favor de comunicarse con su administrador 🙏', "danger" );
        this.toast('b-toaster-bottom-center', true, error.message, "danger" );
        Bugsnag.notify(
            new Error('Método: guardarEvento() ' + error.message)
        );
      }
    }

  },
}
</script>

<style lang="scss" scoped>

$studioAPPColor:#952f81;

.btn-studioAPP{
  color: $studioAPPColor !important;
  border:1px solid $studioAPPColor;
}

.btn-studioAPP:hover, .btn-studioAPP:active{
  background-color: $studioAPPColor !important;
  color: white !important;
}

</style>